import React from 'react';
import { BookmarkFill } from 'react-bootstrap-icons';
import { type IIconProps, type IconProps } from '../dm/icons.js';
import { BibleVersionIcon } from './svg/BibleVersion.js';

const BiblePassageIcon = ({ size, color, ...props }: IIconProps) => {
  return <BookmarkFill height={size} width={size} fill={color} {...props} />;
};

export const passageIcons = ['passage', 'version'];
export type PassageIconType = (typeof passageIcons)[number];

interface IPassageIcons extends IconProps {
  type: PassageIconType;
}
export const PassageIcons = ({ size = '1em', color = 'currentColor', type, className }: IPassageIcons) => {
  const props: IIconProps = { size, color, className };

  switch (type) {
    case 'passage': {
      return BiblePassageIcon(props);
    }
    case 'version': {
      return BibleVersionIcon(props);
    }
  }
};
